import products from "../../api/products";

export default {
  namespaced: true,
  state: {
    items: [],
    editedId: -1,
    editedItem: {
      reference: "",
      description: "",
      descriptionLocal: "",
      currency: "",
      currentCost: 0,
      franchise: null,
      franchiseGroup: null,
      gimBrand: null,
      gimItemType: null,
      gimProductLine: null,
      gimSubBrand: null,
      SAPG: null,
      subFranchise: null,
      targetProductGroup: null,
      gimID: null,
      gimPackContent: 0,
      gimSterilityFlag: 0,
      gimUOM: "",
      gtinCode: "",
      lppr: "",
      price: 0,
      primaryUOM: "",
      tva: null,
      active: false,
      updatedAt: null,
    },
    defaultItem: {
      reference: "",
      description: "",
      descriptionLocal: "",
      currency: "",
      currentCost: 0,
      franchise: null,
      franchiseGroup: null,
      gimBrand: null,
      gimItemType: null,
      gimProductLine: null,
      gimSubBrand: null,
      SAPG: null,
      subFranchise: null,
      targetProductGroup: null,
      gimID: null,
      gimPackContent: 0,
      gimSterilityFlag: 0,
      gimUOM: "",
      gtinCode: "",
      lppr: "",
      price: 0,
      primaryUOM: "",
      tva: null,
      active: false,
      updatedAt: null,
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      const editedItem = {
        reference: item.reference,
        description: item.description,
        descriptionLocal: item.descriptionLocal,
        currency: item.currency,
        currentCost: item.currentCost,
        franchise: item.franchise,
        franchiseGroup: item.franchiseGroup,
        gimBrand: item.gimBrand,
        gimItemType: item.gimItemType,
        gimProductLine: item.gimProductLine,
        gimSubBrand: item.gimSubBrand,
        sapg: item.sapg,
        subFranchise: item.subFranchise,
        targetProductGroup: item.targetProductGroup,
        gimID: item.gimID,
        gimPackContent: item.gimPackContent,
        gimSterilityFlag: item.gimSterilityFlag,
        gimUOM: item.gimUOM,
        gtinCode: item.gtinCode,
        lppr: item.lppr,
        price: item.price,
        primaryUOM: item.primaryUOM,
        tva: item.tva,
        active: item.active,
        updatedAt: item.updatedAt,
      };
      state.editedItem = editedItem;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
  },
  actions: {
    fetchProductForCustomer({ commit }, data) {
      return products.getProductForCustomer(data).then((response) => {
        if (response.data == "No products found") {
          commit("setItems", []);
        } else {
          commit("setItems", response.data);
        }
        return response;
      });
    },
    fetchAll({ commit }, data) {
      return products.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    saveEditedItem({ dispatch, state }) {
      const data = state.editedItem;
      data.FK_Franchise = data.franchise;
      data.FK_FranchiseGroup = data.franchiseGroup;
      data.FK_GimBrand = data.gimBrand;
      data.FK_GimItemType = data.gimItemType;
      data.FK_GimProductLine = data.gimProductLine;
      data.FK_GimSubBrand = data.gimSubBrand;
      data.FK_SAPG = data.sapg;
      data.FK_SubFranchise = data.subFranchise;
      data.FK_TargetProductGroup = data.targetProductGroup;
      delete data.franchise;
      delete data.franchiseGroup;
      delete data.gimBrand;
      delete data.gimItemType;
      delete data.gimProductLine;
      delete data.gimSubBrand;
      delete data.sapg;
      delete data.subFranchise;
      delete data.targetProductGroup;
      return products.store(data).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    updateEditedItem({ dispatch, state }) {
      return products
        .update(state.editedId, state.editedItem)
        .then((response) => {
          dispatch("fetchAll");
          dispatch("resetEditedItem");
          return response;
        });
    },
    deleteItem(context, id) {
      return products.delete(id);
    },
    recalculateColumns() {
      return products.recalculateColumns();
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
